import '@/components/requests/RequestLayout.css';
export const saudiToday = () => new Date().toLocaleDateString('sv-SE', { timeZone: 'Asia/Riyadh' });
export const canCancelRequest = (row, scope = 'general') => {
  if (row.is_archived) return false;
  if (['pending_manager', 'pending_hr'].includes(row.status)) return true;
  const date = scope === 'leave' ? row.start_date : row.filter_snapshot?.event_date;
  return row.status === 'approved' && typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date) && date > saudiToday();
};
// A deleted leave request is stored as cancelled with archive_action "delete";
// show it as deleted, and say when it was the employee's manager who did it.
export const leaveDisplayStatus = (row) => {
  if (row.archive_action !== 'delete') return row.status;
  return row.deleted_by_role === 'manager' ? 'deleted_by_manager' : 'deleted';
};
